import { useQuery } from "@tanstack/react-query";

import { IBillableDevice } from "../../../@types/admin/AdminBillableDevice";
import { billableDevicesService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export function useBillableDevices() {
  const { data, isLoading, isError, isFetching, error, refetch } = useQuery<
    IBillableDevice[]
  >({
    queryKey: ["admin-billable-devices"],
    queryFn: async () =>
      ensureOk(await billableDevicesService.getBillableDevices()),
    // The global QueryClient disables refetchOnMount/focus with a 3-minute
    // staleTime (config/query.ts). Admin pages have no manual Refresh button
    // (EN-5129 UI feedback), so force a fresh fetch every time the page is
    // opened; mutations keep it fresh in between via invalidateQueries.
    refetchOnMount: "always",
  });

  return {
    billableDevices: data ?? [],
    isLoading,
    isError,
    isFetching,
    error,
    refetch,
  };
}

export function useBillableDeviceTypes(enabled: boolean = true) {
  const { data, isLoading, isError } = useQuery<string[]>({
    queryKey: ["admin-billable-device-types"],
    queryFn: async () =>
      ensureOk(await billableDevicesService.getDeviceTypes()),
    enabled,
  });

  return {
    deviceTypes: data ?? [],
    isLoading,
    isError,
  };
}
